import { NAVIGATION_LEARNER_MENU_LIST } from './enums';

export const DefaultTabEnabledMap = {
  homeEnabled: true,
  trainingEnabled: false,
  coachingEnabled: false,
  assetsEnabled: false,
  callAIEnabled: false,
  sellerIntelEnabled: false,
  revenueIntelEnabled: false,
  teamAnalyticsEnabled: false,
  dsrEnabled: false,
  assistantEnabled: false,
  pncRoleplaysEnabled: false,
  dealsEnabled: false,
};

export const NAVIGATION_LEARNER_ICON_LIST: { [key: string]: { light: string; filled: string } } = {
  [NAVIGATION_LEARNER_MENU_LIST.HOME]: {
    light: 'HOME',
    filled: 'HOME_FILLED',
  },
  [NAVIGATION_LEARNER_MENU_LIST.ASSISTANT]: {
    light: 'SPARKLE_LIGHT',
    filled: 'SPARKLE',
  },
  [NAVIGATION_LEARNER_MENU_LIST.TRAINING]: {
    light: 'GRADUATION_CAP',
    filled: 'GRADUATION_CAP_FILLED',
  },
  [NAVIGATION_LEARNER_MENU_LIST.COACHING]: { light: 'COACHING', filled: 'COACHING_FILLED' },
  [NAVIGATION_LEARNER_MENU_LIST.ASSETS]: {
    light: 'FILE_TYPE_PIE_CHART',
    filled: 'FILE_TYPE_PIE_CHART_FILLED',
  },
  [NAVIGATION_LEARNER_MENU_LIST.CALL_AI]: { light: 'WAVE', filled: 'WAVE_FILLED' },
  [NAVIGATION_LEARNER_MENU_LIST.DSR]: { light: 'DSR', filled: 'DSR_FILLED' },
  [NAVIGATION_LEARNER_MENU_LIST.SELLER_INTEL]: {
    light: 'SELLER_INTEL',
    filled: 'SELLER_INTEL_FILLED',
  },
  [NAVIGATION_LEARNER_MENU_LIST.REVENUE_INTELLIGENCE]: {
    light: 'REVENUE_INTEL',
    filled: 'REVENUE_INTEL_FILLED',
  },
  [NAVIGATION_LEARNER_MENU_LIST.TEAM_ANALYTICS]: { light: 'ANALYTICS', filled: 'ANALYTICS_FILLED' },
  [NAVIGATION_LEARNER_MENU_LIST.PNC_ROLEPLAYS]: {
    light: 'USER_HEADSET',
    filled: 'USER_HEADSET_FILLED',
  },
  [NAVIGATION_LEARNER_MENU_LIST.DEALS]: {
    light: 'BADGE_DOLLAR',
    filled: 'BADGE_DOLLAR_FILLED',
  },
};
